<template>
  <div class="ui-table-selection" v-if="items.length > 0">
    <div class="selection-chips">
      <div class="selection-chip" v-for="(item, i) in items" :key="i">
        <span class="chip-text" v-text="getLabel(item)" />
        <i class="fa-solid fa-xmark chip-remove" @click="emit('remove', item, i)" />
      </div>
    </div>
    <div class="selection-actions">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup generic="T extends Record<string, any>">
  const { items, labelKey } = defineProps<{
    items: T[]
    labelKey: keyof T | ((item: T) => string)
  }>()

  const emit = defineEmits<{
    remove: [item: T, index: number]
  }>()

  const getLabel = (item: T): string => {
    if (typeof labelKey === 'function') return labelKey(item)
    const value = item?.[labelKey]
    return value == null ? '' : String(value)
  }
</script>

<style lang="scss" scoped>
  .ui-table-selection {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.5rem 0.75rem;
    background-color: #f7f8fa;
    border: 1px solid $border-color;
    border-radius: 5px;
    margin-bottom: 1rem;

    .selection-chips {
      display: flex;
      flex-wrap: wrap;
      gap: 0.375rem;
      flex: 1;
      min-width: 0;

      .selection-chip {
        display: inline-flex;
        align-items: center;
        gap: 0.375rem;
        background-color: $white;
        border: 1px solid $border-color;
        color: $primary-text-color;
        border-radius: 5px;
        padding: 0.2rem 0.6rem;
        font-size: 13px;
        max-width: 260px;

        .chip-text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .chip-remove {
          cursor: pointer;
          font-size: 11px;
          color: #aaa;
          transition: color 0.2s;
          flex-shrink: 0;

          &:hover {
            color: $danger;
          }
        }
      }
    }

    .selection-actions {
      display: flex;
      gap: 0.5rem;
      flex-shrink: 0;
    }

    @include media(xs, sm) {
      flex-direction: column;
      align-items: stretch;
      gap: 0.75rem;

      .selection-chips {
        .selection-chip {
          max-width: 100%;
          font-size: 12px;
        }
      }

      .selection-actions {
        justify-content: flex-end;
        flex-wrap: wrap;
      }
    }
  }
</style>
